import { z } from 'zod';
export const financeInsuranceClaimsBillingCapability = 'finance.project-billing-summary.v1';
export const financeInsuranceClaimsBillingSlot = 'insurance-claims.project-billing-summary';
export const financeInsuranceClaimsBillingProviderId = 'finance.server.insurance-claims-billing';
const idSchema = z.string().uuid();
const countSchema = z.number().int().nonnegative();
const centsSchema = z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER);
export const financeInsuranceClaimsBillingRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(financeInsuranceClaimsBillingCapability),
    resourceType: z.literal('insurance-claims.claim'),
    resourceId: idSchema,
    projectId: idSchema,
});
export const financeInsuranceClaimsBillingStatusCountsSchema = z.strictObject({
    draft: countSchema,
    sent: countSchema,
    partial: countSchema,
    paid: countSchema,
    void: countSchema,
});
export const financeInsuranceClaimsBillingResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(financeInsuranceClaimsBillingCapability),
    projectId: idSchema,
    currencyCode: z.literal('USD'),
    invoiceCount: countSchema,
    nonvoidInvoiceCount: countSchema,
    byStatus: financeInsuranceClaimsBillingStatusCountsSchema,
    totalBilledCents: centsSchema,
    totalPaidCents: centsSchema,
    totalWrittenOffCents: centsSchema,
    totalDueCents: centsSchema,
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    observedAt: z.string().datetime({ offset: true }).nullable(),
}).superRefine((value, context) => {
    const statusTotal = Object.values(value.byStatus).reduce((sum, count) => sum + count, 0);
    if (statusTotal !== value.invoiceCount) {
        context.addIssue({ code: 'custom', path: ['invoiceCount'], message: 'Invoice status counts must reconcile.' });
    }
    if (value.invoiceCount - value.byStatus.void !== value.nonvoidInvoiceCount) {
        context.addIssue({ code: 'custom', path: ['nonvoidInvoiceCount'], message: 'Nonvoid invoice count must exclude void invoices.' });
    }
    const reconciledDue = value.totalBilledCents - value.totalPaidCents - value.totalWrittenOffCents;
    if (reconciledDue < 0 || reconciledDue !== value.totalDueCents) {
        context.addIssue({ code: 'custom', path: ['totalDueCents'], message: 'Project billing totals must reconcile exactly.' });
    }
});
//# sourceMappingURL=finance-insurance-claims-billing.contract.js.map